export const arrowColor = (isPrimary: boolean) => (isPrimary ? "primary.500" : "greyscale.500");
